import { useMemo } from 'react';
import { omitBy } from 'es-toolkit';
import useAnalyticsStore from '@/modules/Analytics/Analytics.store.ts';
import { ILogsFilter } from '@/modules/Analytics/Analytics.types.ts';

const useFiltersToParams = () => {
    const filters = useAnalyticsStore((state) => state.filters);

    const params = useMemo(() => {
        const { userPersona, userActor, agentPersona, ...rest } = filters;
        // omit falsy values
        const data = omitBy(rest, (value: unknown) => !value) as ILogsFilter;
        return {
            ...data,
            user_persona_ids: userPersona?.id,
            user_actor_ids: userActor?.id,
            agent_persona_ids: agentPersona?.id
        };
    }, [filters]);

    return {
        params
    };
};

export default useFiltersToParams;
